let global: any = {};

export function setConfig(config: any) {
  global = config;
}

export function getConfig() {
  return global;
}

/**
 * Base URL for portal REST calls ({@code .../api/...}) and {@code /api/encrypt/get-key}.
 * Must match wherever hybrid RSA keys are stored; if get-key hits one host and POST hits another, decrypt fails with unknown key id.
 */
export function resolvePortalApiBaseUrl(): string {
  const root = getConfig()?.VITE_APP_ROOT_API;
  if (root && String(root).trim()) {
    return `${String(root).replace(/\/$/, "")}/api`;
  }
  return "/api";
}

export default class Constants {
  // static BASE_URL = import.meta.env.VITE_APP_ROOT_API;
  // static RESPONSE_URL = import.meta.env.VITE_APP_RESPONSE_URL;
  // static API_PREFIX = import.meta.env.VITE_APP_API_PREFIX;
  // static VERSION = import.meta.env.VITE_APP_VERSION;
  // static AMP_TERM_CONDITION = import.meta.env.VITE_AMP_TERM_CONDITION_URL;
  // static AMP_PRIVACY_POLICY = import.meta.env.VITE_AMP_PRIVACY_POLICY_URL;
  // static BT_DECLARATION = import.meta.env.VITE_BT_DECLARATION_URL;
  // static FILE_SIZE = import.meta.env.VITE_FILE_SIZE;
  // static PLAY_STORE = import.meta.env.VITE_PLAY_STORE_URL;
  // static APPSTORE = import.meta.env.VITE_APPSTORE_URL;
  // static AEON_CREDIT = import.meta.env.VITE_AEON_CREDIT_URL;
  // static AEON_CC_TNC = import.meta.env.VITE_AEON_CC_TNC_URL;
  // static AEON_CC_PSD = import.meta.env.VITE_AEON_CC_PSD_URL;
  // static COMSUMER_API = import.meta.env.VITE_APP_CONSUMER_URL;
  // static AEON_CREDIT_TEXT = import.meta.env.VITE_AEON_CREDIT_TEXT;
  // static AEON_CUSTOMER_SERVICE = import.meta.env.VITE_AEON_CUSTOMER_SERVICE;
  // static APP_QR = import.meta.env.VITE_AEON_APP_QR;
  // static PRODUCT_BUNDLING_TIME_OUT = import.meta.env
  //   .VITE_PRODUCT_BUNDLING_TIME_OUT;
  // static OTHERS_TIME_OUT = import.meta.env.VITE_OTHERS_TIME_OUT;
  // static AEON_E_INVOICE = import.meta.env.VITE_AEON_E_INVOICE;

  static get ENV() {
    return getConfig().VITE_NODE_ENV || "";
  }
  static get BASE_URL() {
    return getConfig().VITE_APP_ROOT_API || "";
  }
  static get RESPONSE_URL() {
    return getConfig().VITE_APP_RESPONSE_URL || "";
  }
  static get API_PREFIX() {
    return getConfig().VITE_APP_API_PREFIX || "";
  }
  static get VERSION() {
    return getConfig().VITE_APP_VERSION || "";
  }
  static get AMP_TERM_CONDITION() {
    return getConfig().VITE_AMP_TERM_CONDITION_URL || "";
  }
  static get AMP_PRIVACY_POLICY() {
    return getConfig().VITE_AMP_PRIVACY_POLICY_URL || "";
  }
  static get BT_DECLARATION() {
    return getConfig().VITE_BT_DECLARATION_URL || "";
  }
  static get FILE_SIZE() {
    return getConfig().VITE_FILE_SIZE || "";
  }
  static get PLAY_STORE() {
    return getConfig().VITE_PLAY_STORE_URL || "";
  }
  static get APPSTORE() {
    return getConfig().VITE_APPSTORE_URL || "";
  }
  static get AEON_CREDIT() {
    return getConfig().VITE_AEON_CREDIT_URL || "";
  }
  static get AEON_CC_TNC() {
    return getConfig().VITE_AEON_CC_TNC_URL || "";
  }
  static get AEON_CC_PSD() {
    return getConfig().VITE_AEON_CC_PSD_URL || "";
  }
  static get COMSUMER_API() {
    return getConfig().VITE_APP_CONSUMER_URL || "";
  }
  static get AEON_CREDIT_TEXT() {
    return getConfig().VITE_AEON_CREDIT_TEXT || "";
  }
  static get AEON_CUSTOMER_SERVICE() {
    return getConfig().VITE_AEON_CUSTOMER_SERVICE || "";
  }
  static get APP_QR() {
    return getConfig().VITE_AEON_APP_QR || "";
  }
  static get PRODUCT_BUNDLING_TIME_OUT() {
    return getConfig().VITE_PRODUCT_BUNDLING_TIME_OUT || "";
  }
  static get OTHERS_TIME_OUT() {
    return getConfig().VITE_OTHERS_TIME_OUT || "";
  }
  static get AEON_E_INVOICE() {
    return getConfig().VITE_AEON_E_INVOICE || "";
  }
}
